@if (showOfferings) {
  <div [formGroup]="form">
    <div class="search-field">
      <app-ice-search-field
        placeholder="Søk..."
        [value]="searchValue"
        (searchTriggered)="onFilterChange($event, { value: offeringFiltersValue })"
      />
    </div>
    <mat-button-toggle-group
      class="ice-custom-button-toggle"
      hideSingleSelectionIndicator
      [disabled]="activeFilters.length <= 1"
      [value]="offeringFiltersValue"
      (change)="onFilterChange(searchValue, $event)"
    >
      @for (item of activeFilters; track item + $index) {
        <mat-button-toggle data-testid="voice-offerings-list-filter" [value]="item">
          {{ item.toString() }}
        </mat-button-toggle>
      }
    </mat-button-toggle-group>
    <div class="offering-list-wrapper">
      @for (
        item of sortOfferingsByMobilePlanTypeAndPrice(allowedOfferingsFiltered, allowedOfferingsTypesOnTop);
        track item.subscriptionOffering?.id
      ) {
        @if (+item.subscriptionOffering.id !== assignedSubscription?.subscriptionNo) {
          @if (!!getVasProductFromOffering(item.subscriptionOffering)) {
            <app-vas-voice-offering-item
              class="ice-radio-list-item-wrapper"
              [assignedSubscription]="assignedSubscription"
              [changeInfo]="item.changeInfo"
              [control]="form.controls.offering"
              [isChangingSubscription]="product.isExistingSubscription"
              [offering]="item.subscriptionOffering"
              [subscriber]="product.subscriber"
            />
          } @else {
            <app-voice-offering-item
              class="ice-radio-list-item-wrapper"
              [assignedSubscription]="assignedSubscription"
              [changeInfo]="item.changeInfo"
              [control]="form.controls.offering"
              [isExistingSubscription]="product.isExistingSubscription"
              [offering]="item.subscriptionOffering"
              [sponsor]="product.sponsor"
              [subscriber]="product.subscriber"
              (sponsorSelected)="onSponsorSelected($event)"
              (sponsorTypeSelected)="onSponsorTypeSelected($event)"
            />
          }
        }
      }
      @if (allowedOfferingsFiltered?.length === 0) {
        <div class="no-search-results">Ingen resultater</div>
      }
    </div>
  </div>
}
